import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiMe, apiLogin, apiRegister, apiLogout, apiGoogleSession } from "../lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  const checkAuth = useCallback(async () => {
    try {
      const u = await apiMe();
      setUser(u);
    } catch {
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    // Skip /me while returning from Google OAuth (AuthCallback handles it)
    if (window.location.hash?.includes("session_id=")) {
      setReady(true);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (payload) => {
    const u = await apiLogin(payload);
    setUser(u);
    return u;
  };
  const register = async (payload) => {
    const u = await apiRegister(payload);
    setUser(u);
    return u;
  };
  const googleSession = async (sessionId) => {
    const u = await apiGoogleSession(sessionId);
    setUser(u);
    return u;
  };
  const logout = async () => {
    await apiLogout();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, googleSession, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};
